var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSacola(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2248 28.83H9.74982C8.00982 28.83 6.64482 27.36 6.74982 25.635L7.87482 8.16C7.91982 7.365 8.57982 6.75 9.37482 6.75H27.5998C28.3948 6.75 29.0398 7.365 29.0998 8.16L30.2248 25.635C30.3298 27.36 28.9648 28.83 27.2248 28.83Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4403 10.08V12.945C22.4403 14.55 21.1353 15.84 19.5453 15.84H17.4453C15.8403 15.84 14.5503 14.535 14.5503 12.945V10.08",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4403 10.08V12.945C22.4403 14.55 21.1353 15.84 19.5453 15.84H17.4453C15.8403 15.84 14.5503 14.535 14.5503 12.945V10.08",
    stroke: "#00213F",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSacola);
export default __webpack_public_path__ + "static/media/sacola.983b07c34b667d2643b3743017a5179b.svg";
export { ForwardRef as ReactComponent };